import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {environment} from '@environments/environment';
import {TokenStoreService} from '@core/services/token/token-store.service';
import {SKIP_AUTH_TOKEN} from '@core/interceptors/skip-auth-token.context';

const PUBLIC_API_PATHS = [
  '/api/auth/login',
  '/api/auth/signup',
  '/api/auth/refresh-token',
  '/api/auth/send-phone-otp',
  '/api/auth/verify-phone-otp',
  '/api/auth/forgot-password/send-otp',
  '/api/auth/forgot-password/send-email-link',
  '/api/auth/forgot-password/verify-otp',
  '/api/auth/reset-password',
];

export const authTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const accessToken = inject(TokenStoreService).getToken().accessToken;

  if (
    !accessToken ||
    request.context.get(SKIP_AUTH_TOKEN) ||
    !shouldAttachAccessToken(request.url) ||
    request.headers.has('Authorization')
  ) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    }),
  );
};

function shouldAttachAccessToken(requestUrl: string): boolean {
  if (!requestUrl.startsWith(environment.baseUrl)) {
    return false;
  }

  const apiPath = requestUrl.slice(environment.baseUrl.length);

  return !PUBLIC_API_PATHS.some((publicPath) => apiPath.startsWith(publicPath));
}
